var exports = {
  "Z": "xcc377c0b--2c812f--layout",
};

module.exports = exports;
